const { useEffect, useRef } = require('react');
const LoadingScreen = require('components/LoadingScreen');
const { context } = require('app-context');
const { useAppSelector } = require('utils/redux');
const RoutingTable = require('services/auth-management/routing-table');
const AuthRoutes = require('routes/auth/config');
const Continuation = require('services/auth-management/continuation');

const { replace: Replace } = require('connected-react-router');

const {
    selectors: { all: selectors }
} = context;

const redux = context.redux.hooks;

const internals = {};

module.exports = function AppLoader({ location } = {}) {

    const isMainAppLoading = useAppSelector(selectors.getMainAppLoading);
    const redirectDestination = RoutingTable.getRedirectDestination(location);
    const message = 'Logging in...';

    // Always assume main app is loading when this component renders
    const prevAppLoadingVal = useRef(true);

    useEffect(() => {

        console.info('[app-loader] effect tick', {
            isMainAppLoading,
            redirectDestination,
            previousLoading: prevAppLoadingVal.current,
            pathname: window.location.pathname,
            search: window.location.search
        });

        // When isMainAppLoading changes from true to false
        // and this app is loaded, we want to redirect.
        if (prevAppLoadingVal.current && !isMainAppLoading) {
            const currentPath = `${location?.pathname || window.location.pathname || ''}${location?.search || window.location.search || ''}`;
            const targetRedirect = internals.resolveBootRedirectTarget({
                redirectDestination,
                currentPath
            });

            if (!targetRedirect) {
                console.info('[app-loader] skipping replace because route already matches target', {
                    currentPath
                });
                return;
            }

            console.info('[app-loader] replacing route after bootstrap', {
                targetRedirect
            });
            if (!Continuation.isDeferred()) {
                Continuation.consume();
            }
            redux.dispatch(Replace(targetRedirect));
        }

        // Update the previous value after each render
        prevAppLoadingVal.current = isMainAppLoading;
    }, [isMainAppLoading, redirectDestination, location]);

    return <LoadingScreen variant='screen' message={message} />;
};

internals.DEFAULT_SUCCESS_REDIRECT_PATH = AuthRoutes.app.welcome;
internals.LOADER_PATH = AuthRoutes.app.loader;

internals.resolveBootRedirectTarget = ({
    redirectDestination,
    currentPath
}) => {

    const requestedRedirectPath = internals.removeConsumedRedirectContext(
        redirectDestination || internals.DEFAULT_SUCCESS_REDIRECT_PATH
    );

    if (requestedRedirectPath === internals.LOADER_PATH) {
        return internals.DEFAULT_SUCCESS_REDIRECT_PATH;
    }

    if (currentPath === requestedRedirectPath) {
        return null;
    }

    return requestedRedirectPath;
};

internals.removeConsumedRedirectContext = (path) => {

    const hashIndex = path.indexOf('#');
    const hash = hashIndex === -1 ? '' : path.slice(hashIndex);
    const pathAndSearch = hashIndex === -1 ? path : path.slice(0, hashIndex);
    const searchIndex = pathAndSearch.indexOf('?');
    const pathname = searchIndex === -1 ? pathAndSearch : pathAndSearch.slice(0, searchIndex);
    const search = searchIndex === -1 ? '' : pathAndSearch.slice(searchIndex + 1);
    const query = new URLSearchParams(search);

    query.delete('redirect');
    query.delete('target');

    const nextSearch = query.toString();

    return `${pathname}${nextSearch ? `?${nextSearch}` : ''}${hash}`;
};

module.exports.internals = internals;
